import { render } from "./fullHtml.vue?vue&type=template&id=3b161164"
import script from "./fullHtml.vue?vue&type=script&lang=js"
export * from "./fullHtml.vue?vue&type=script&lang=js"

import "./fullHtml.vue?vue&type=style&index=0&id=3b161164&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__